export default __webpack_public_path__ + "static/media/estrella.d1561b28.svg";